import { useEffect } from 'react';

import App from '@/ui/app';
import { EMBEDDABLE_SIGNER } from '@/ui/constants';
import AppContext from '@/ui/context';
import Signer from '@/ui/signer';
import { WALLET_READY_MESSAGE } from '@/ui/utils/messages';
import { referrerURL } from '@/utils/referrer';
import PopupFailGuard from './components/popup-fail-guard/index.js';

const Root = () => {
  useEffect(() => {
    if (referrerURL) {
      window.parent.postMessage(WALLET_READY_MESSAGE, referrerURL);
    }
  }, []);

  return (
    <AppContext>
      {EMBEDDABLE_SIGNER && <Signer />}
      {__STANDALONE_MODE__ && <PopupFailGuard />}
      <App />
    </AppContext>
  );
};

export default Root;
